import React, { useEffect, useRef, useState } from "react";
import { getBaseUrl } from "../../../../../../Redux/Config/AppConfig";
import { useDispatch, useSelector } from "react-redux";
import { POST_DEPARTMENT_REQUEST, PUT_DEPARTMENT_REQUEST } from "../../../../../../Utils/Constant";

const AddDepartments = ({
  selectedDepartment,
  setSelectedCategory,
}) => {
  const BaseUrl = getBaseUrl();
  const closeBtnRef = useRef(null);
  const dispatch = useDispatch();
//    const { addCategory } = useSelector((state) => state.restaurant);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedDepartment) {
      setFormData({
        name: selectedDepartment.name || "",
        description: selectedDepartment.description || "",
      });
    } else {
      setFormData({ name: "", description: "" });
    }
    setErrors({});
  }, [selectedDepartment]);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Category name is required.";
    // if (!formData.description.trim())
    //   newErrors.description = "Description is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async () => {
    if (!validate()) return;
const hotel_id=localStorage.getItem('hotel_id')
    if (selectedDepartment) {
      dispatch({
        type: PUT_DEPARTMENT_REQUEST,
        payload: { id: selectedDepartment?.id, body: {...formData, hotel_id} },
      });
    } else {
      dispatch({
        type: POST_DEPARTMENT_REQUEST,
        payload: { body: {...formData, hotel_id} },
      });
    }
      setFormData({ name: "", description: "" });
      setErrors({});
    closeBtnRef.current?.click();
  };

  const handleClear = () => {
    setFormData({ name: "", description: "" });
    setErrors({});
  };

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="add-department"
      aria-labelledby="add-department"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">
          {selectedDepartment ? "Edit Department" : "Add Department"}
        </h5>
        <button
          ref={closeBtnRef}
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => setErrors({})}
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Department Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="name"
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter department name"
          />
          {errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>

        <div className="form-group mb-3">
          <label className="form-label text-muted">
            Description
             {/* <span className="text-danger">*</span> */}
          </label>
          <textarea
            name="description"
            className={`form-control ${errors.description ? "is-invalid" : ""}`}
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter department description"
          ></textarea>
          {errors.description && (
            <div className="invalid-feedback">{errors.description}</div>
          )}
        </div>

        <div className="d-flex">
          <button
            type="button"
            className="btn w-100 me-1 py-2 btn-primary"
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            type="button"
            className="btn w-100 ms-1 py-2 btn-dark"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDepartments;
